import { PASSWORD_REGEX } from '../regexConstants'

export default [
  {
    name: 'password',
    label: 'Old Password',
    errorMessage: 'Enter password (min 6 characters)',
    required: true,
    type: 'password',
    pattern: PASSWORD_REGEX,
  },
  {
    name: 'new_password',
    label: 'New Password',
    errorMessage: 'Enter password (min 6 characters)',
    required: true,
    type: 'password',
    pattern: PASSWORD_REGEX,
  },
  {
    name: 'confirm_new_password',
    label: 'Re-enter New Password',
    errorMessage: 'Re-enter password (should be same as above)',
    required: true,
    type: 'password',
    pattern: PASSWORD_REGEX,
  },
]
